
import 'virtual:svg-icons-register'
import svgIcon from '@/components/svg-icon/index.vue'
import textTooltip from '@/components/text-tooltip/index.vue'

export default function loadComponents(app) {
  app.component('svg-icon', svgIcon)
  app.component('text-tooltip', textTooltip)
}